import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

var ring = defineStyle({});
var dots = defineStyle({});
var sizes = defineStyle({
    sm: {
        width: '16px',
        height: '16px'
    },
    md: {
        width: '24px',
        height: '24px'
    },
    lg: {
        width: '32px',
        height: '32px'
    }
});
var spinnerTheme = defineStyleConfig({
    defaultProps: {
        size: 'md',
        variant: 'ring'
    },
    variants: { dots: dots, ring: ring },
    sizes: sizes
});

export { spinnerTheme };
//# sourceMappingURL=spinner.js.map
